// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Pdhm","unreadBadge":"styles_unreadBadge__3C0sA","modalContent":"styles_modalContent__hVa_F","modal":"styles_modal__3FOHh"};